var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9842 22.8713L20.3116 15.0912C19.3011 14.434 17.9866 15.1426 17.9866 16.3544V31.917C17.9866 33.1288 19.3504 33.8374 20.3116 33.1802L31.9842 25.4001C32.8941 24.7922 32.8941 23.4778 31.9842 22.8718V22.8713Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 0.136719C10.7626 0.136719 0 10.8993 0 24.1367C0 37.3741 10.7626 48.1367 24 48.1367C37.2374 48.1367 48 37.3741 48 24.1367C48 10.8993 37.2374 0.136719 24 0.136719ZM24 44.3988C12.8327 44.3988 3.73794 35.304 3.73794 24.1367C3.73794 12.9694 12.8327 3.87466 24 3.87466C35.1673 3.87466 44.2621 12.9694 44.2621 24.1367C44.2621 35.304 35.1673 44.3988 24 44.3988Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayBtn);
export default __webpack_public_path__ + "static/media/play-btn.8115776c4a6dfe850fe75c553ca60bb4.svg";
export { ForwardRef as ReactComponent };